<template>
  <div v-b-tooltip.top :title="trimMessage(request.description, 15)" class="item cashout p-2 row-direction fit-content" :class="getClassVariant">
    <div class="col-direction fit-content">
      <div><strong>{{ request.bank_name }}</strong></div>
      <div>{{ request.user.account_number }}</div>
    </div>
    <div class="col-direction fit-content cashout-info">
      <div><strong>{{ request.amount | currency('', '₮') }}</strong></div>
      <div>{{ request.created_at | formatDate('date') }}</div>
    </div>
    <div class="col-direction fit-content cashout-info">
      <div><b-badge :variant="variant">{{ StateOption[request.state].text }}</b-badge></div>
      <button 
        class="btn cancel-button" 
        v-b-tooltip.top 
        title="Цуцлах" 
        size="xs" 
        :disabled="request.state === 'cancelled' || request.state === 'approved'" @click="cancelRequest(request)"> 
          <i class="sr sr-trashcan"></i>
      </button>
    </div>

    <!-- <div class="row-direction fit-content"> -->
    <!--   <div>{{ request.bank_name }}</div> -->      
    <!--   <div>{{ request.amount | currency('', '₮') }}</div> -->
    <!-- </div> -->
    <!-- <div class="row-direction fit-content"> -->
    <!--   <div>{{ request.user.account_number }}</div> -->
    <!--   <div><span :title="request.description">{{ trimMessage(request.description, 15) }}</span></div> -->
    <!--   <b-col><b-badge :variant="variant">{{ StateOption[request.state].text }}</b-badge></b-col> -->
    <!-- </div> -->

    <!-- <b-row> -->
    <!--   <b-col>{{ request.created_at | formatDate('date') }}</b-col> -->
    <!--   <b-col> -->
    <!--     <b-button variant="outline-danger" v-b-tooltip.top title="Цуцлах" size="xs" class="cancel-button" :disabled="request.state === 'cancelled' || request.state === 'approved'" @click="cancelRequest(request)"> -->
    <!--       <span> -->
    <!--         <i class="fas fa-trash"></i> -->
    <!--       </span> -->
    <!--     </b-button> -->
    <!--   </b-col> -->
    <!-- </b-row> -->
  </div>
</template>

<script>
const StateOption = {
  approved: { variant: 'success', text: 'Биелсэн', },
  cancelled: { variant: 'danger', text: 'Цуцалсан', },
  new: { variant: 'info', text: 'Шинэ', },
  done: { variant: 'success', text: 'Биелсэн', },
  null: { variant: 'dark', text: 'NA', },
  undefined: { variant: 'dark', text: 'NA', }
};

export default {
  props: {
    request: {
      type: Object,
      required: true
    },
    cancelRequest: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      StateOption,
    };
  },
  computed: {
    getClassVariant() {
      return 'order-' + this.variant;
    },
    variant() {
      return this.StateOption[this.request.state].variant;
    }
  },
  methods: {
  }
} 
</script>

<style lang='scss' scoped>
@media (max-width: 460px) {
  .cashout {
    display: flex;
    flex-direction: column;

    &-info {
      flex-direction: row;
    }
  }
}
</style>
